import React, { useContext } from 'react';
import { Context } from '../../../store';
import { ReactComponent as SpotifyIcon } from '../../../images/new_icons/spotify-icon.svg';
import { ReactComponent as AppleIcon } from '../../../images/new_icons/apple-music-icon.svg';
import { ReactComponent as YandexIcon } from '../../../images/new_icons/ya-music-icon.svg';
import { ReactComponent as YouTubeIcon } from '../../../images/new_icons/youtube_str.svg';
import { reportTrackFeedback } from '../../../services/reportingService';

const FavoritesScreen = () => {
    const [state, dispatch] = useContext(Context);
    const favorites = state.favorites || [];

    const getSearchUrl = (service, artist, track) => {
        const query = encodeURIComponent(`${artist} - ${track}`);
        switch (service) {
            case 'spotify':
                return `https://open.spotify.com/search/${query}`;
            case 'apple':
                return `https://music.apple.com/search?term=${query}`;
            case 'yandex':
                return `https://music.yandex.ru/search?text=${query}`;
            case 'youtube':
                return `https://www.youtube.com/results?search_query=${query}`;
            default:
                return '#';
        }
    };

    const removeFromFavorites = (itemToRemove) => {
        const newFavorites = favorites.filter(item => 
            !(item.artist === itemToRemove.artist && item.track === itemToRemove.track)
        );
        dispatch({ favorites: newFavorites });
        
        // Report as DELETE (pruning the list)
        reportTrackFeedback({
            artist: itemToRemove.artist,
            track: itemToRemove.track,
            stream: itemToRemove.stream || 'myata', // Fallback to myata if stream info is missing
            type: 'DELETE'
        });
    };

    const exportToCSV = () => {
        const header = 'Artist,Track,Added At\n';
        const rows = favorites.map(item => 
            `"${item.artist}","${item.track}","${item.addedAt}"`
        ).join('\n');
        
        const blob = new Blob([header + rows], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'myata_favorites.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const exportToTXT = () => {
        const content = favorites.map(item => 
            `${item.artist} - ${item.track}`
        ).join('\n');
        
        const blob = new Blob([content], { type: 'text/plain;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'myata_favorites.txt');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="mobile-screen favorites-screen">
            <h2 className="screen-title">ВАША КОЛЛЕКЦИЯ</h2>
            
            <div className="favorites-form">
                <div className="favorites-form-header">
                    <div className="favorites-actions">
                        <button onClick={exportToTXT} className="export-btn">Скачать TXT</button>
                        <button onClick={exportToCSV} className="export-btn">Скачать CSV</button>
                    </div>
                </div>

                <div className="favorites-list">
                    {favorites.length > 0 ? (
                        favorites.map((item, index) => (
                            <div key={index} className="favorite-item">
                                <div className="favorite-header">
                                    <div className="favorite-info">
                                        <div className="favorite-artist">{item.artist}</div>
                                        <div className="favorite-track">{item.track}</div>
                                    </div>
                                    {item.stream && (
                                        <div className={`favorite-stream-badge stream-${item.stream}`}>
                                            {item.stream === 'myata_hits' ? 'XTRA' : item.stream.toUpperCase()}
                                        </div>
                                    )}
                                </div>
                                <div className="favorite-controls">
                                    <div className="favorite-links">
                                        <a href={getSearchUrl('spotify', item.artist, item.track)} target="_blank" rel="noreferrer" className="favorite-link">
                                            <SpotifyIcon />
                                        </a>
                                        <a href={getSearchUrl('apple', item.artist, item.track)} target="_blank" rel="noreferrer" className="favorite-link">
                                            <AppleIcon />
                                        </a>
                                        <a href={getSearchUrl('yandex', item.artist, item.track)} target="_blank" rel="noreferrer" className="favorite-link">
                                            <YandexIcon />
                                        </a>
                                        <a href={getSearchUrl('youtube', item.artist, item.track)} target="_blank" rel="noreferrer" className="favorite-link">
                                            <YouTubeIcon />
                                        </a>
                                    </div>
                                    <button 
                                        className="remove-btn" 
                                        onClick={() => removeFromFavorites(item)}
                                    >
                                        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        )).reverse() // Most recently added first
                    ) : (
                        <div className="favorites-empty">Твой идеальный плейлист начинается с первого лайка!</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FavoritesScreen;
